<div class="wrapper-reponsive">
    <div class="tlt-green-row mt-3">
        {{ 'STR_TOPPAGE' | translate }}
    </div>
    <div class="content-box mt-2 mb-4" *ngIf="lstInfoHtRsv.length >0 || lstInfoInterviewRecept.length >0  ">
        <div class="tlt-border mb-3">
            {{'STR_RESER_INSPEC_HIS' | translate }}
        </div>
        <div class="box-common bg-common-red mb-2" *ngFor="let rsv of lstInfoHtRsv">
            <div class="tlt-dot dot-red m-0">
                {{getDayName(rsv.RsvDate,rsv.DateOfWeek)+' '+ getTimeDisplay(rsv.RsvTime)}} 
            </div>
            <div class="box-desc">
                <div class="row">
                    <div class="col-6 pr-0">
                        <a href="{{rsv.HomepageURL}}" target="_blank">
                            <strong>{{rsv.HTOrgName}}</strong>
                        </a>
                    </div>
                    <div class="col-6">
                        <span style="word-break: break-word;">{{ rsv.HTCourseName}}</span>
                    </div>
                </div>
                <div class="lst-button mt-1">
                    <button class="btn btn-bg-red mt-2" [disabled]="rsv.InputStatusDiv!='1'" *ngIf="rsv.InputStatusDiv=='1'" (click)="go0501(rsv)">{{'STR_INTERVIEW_INCOMPLETE_BTN' | translate}}</button>
                    <button class="btn mt-2" [disabled]="rsv.InputStatusDiv!='2'" *ngIf="rsv.InputStatusDiv=='2'" (click)="go0501(rsv)">{{'STR_INTERVIEW_COMPLETE_BTN' | translate}}</button>
                    <button class="btn btn-bg-yellow ml-3 mt-2"  *ngIf="isEnbledInCom(rsv)" (click)="go0307(rsv, 1)">{{'STR_CHANGE_RESER_CONFIRM_BTN' | translate}}</button>
                    <button class="btn btn-bg-yellow ml-3 mt-2" *ngIf="isEnableCom(rsv)"    (click)="go0307(rsv, 2)">{{'STR_BTN_CONFIRM_RESERVATION' | translate}}</button>
                </div>
                <div class="row mt-2" >
                    <div class="col-12" [innerHTML]="getWarning(rsv)"  *ngIf="isEnableCom(rsv)" >
                    </div>
                </div>
            </div>
        </div>
        
        <div class="box-common mb-2" *ngFor="let info of lstInfoInterviewRecept">
            <div class="tlt-dot m-0">
                {{getDayName(info.ConsulDay,info.DateOfWeek)}}
            </div>
            <div class="box-desc">
                <div class="row">
                    <div class="col-6 pr-0">
                        <a href="{{info.HomepageURL}}" target="_blank">
                            <strong>{{info.HTOrgName}}</strong>
                        </a>
                    </div>
                    <div class="col-6">
                        <span style="word-break: break-word;">{{ info.HTCourseName}}</span>
                    </div>
                </div>
                <div class="lst-button mt-3">
                    <button class="btn" *ngIf="info.JudgeDiv=='3'"  (click)="go0601(info)">{{'STR_INSPECTION_RESULT_CONFIRM' | translate}}</button>
                    <button class="btn btn-bg-gray" *ngIf="info.JudgeDiv!='3'" [disabled]="true">{{'STR_RESULT_NOT_YET_CONFIRMED' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="content-box mt-2 mb-4" *ngIf="lstInfoHtRsv.length ==0 && lstInfoInterviewRecept.length ==0 && isInit == false ">
        <div class="tlt-border mb-3">
            {{'STR_RESER_INSPEC_HIS' | translate }}
        </div>
        <div class="box-common" >
            <div class="box-desc">
                <p><strong class="text-orange"> {{'STR_NO_MEDICAL_HISTORY' | translate }}</strong></p>
                <p> {{'STR_NO_MEDICAL_HISTORY_GUIDE' | translate }}</p>
            </div>
        </div>    
    </div>    
</div>
